import { FC, ReactNode } from 'react';
import BordTooltip from 'components/BordTooltip/BordTooltip';
import { IBordTooltipProps } from 'components/BordTooltip/BordTooltip.type';
import { SwitchText, SwitchStatus } from 'views/business/BusinessListing/components/SwitchText/SwitchText';

import './LabeledSwitchTextItem.scss';

const LabeledSwitchTextItem: FC<LabeledSwitchTextItemProps> = ({
  label,
  value,
  onChange,
  disabled,
  customControl,
  isFirst,
  customStyles,
  activeLabel = 'Sí',
  inactiveLabel = 'No',
  className = '',
  tooltipProps
}) => {
  const status = value ? SwitchStatus.ACTIVE : SwitchStatus.INACTIVE;

  const handleChange = (newValue: boolean | React.ChangeEvent<HTMLInputElement>) => {
    if (!disabled && onChange) {
      const boolValue = typeof newValue === 'boolean' ? newValue : newValue?.target?.checked;
      onChange(Boolean(boolValue));
    }
  };

  const renderControl = () => {
    if (customControl) return customControl;

    return (
      <div className={disabled ? 'labeledSwitchTextItemSwitchDisabled' : ''}>
        <SwitchText
          status={status}
          handleChangeStatus={handleChange}
          activeLabel={activeLabel}
          inactiveLabel={inactiveLabel}
          isDisabled={disabled}
        />
      </div>
    );
  };

  const rootClassName = `labeledSwitchTextItem ${isFirst ? 'labeledSwitchTextItemFirst' : ''} ${className}`.trim();

  const row = (
    <div className={rootClassName} style={customStyles}>
      <span className="labeledSwitchTextItemLabel">{label}</span>
      {renderControl()}
    </div>
  );

  if (tooltipProps) {
    return <BordTooltip {...tooltipProps}>{row}</BordTooltip>;
  }

  return row;
};

export default LabeledSwitchTextItem;

export type { IBordTooltipProps };

export interface LabeledSwitchTextItemProps {
  label: string;
  value?: boolean;
  onChange?: (value: boolean) => void;
  disabled?: boolean;
  customControl?: ReactNode;
  isFirst?: boolean;
  customStyles?: React.CSSProperties;
  activeLabel?: string;
  inactiveLabel?: string;
  className?: string;
  tooltipProps?: Omit<IBordTooltipProps, 'children'>;
}
